import type { Invoice, InvoiceWritable } from '@bambi/api-client/schemas';

import {
  editInvoice,
  resetEditing,
  setHydratedInvoice,
  setInvoiceModalOpen,
} from '../invoice.slice';
import type { HydratedInvoice } from '../useHydratedInvoice';
import { useAppDispatch } from 'src/app/store/hooks';

export function useCreateEmptyInvoice() {
  const dispatch = useAppDispatch();

  return (invoice?: Partial<InvoiceWritable>) => {
    dispatch(resetEditing());
    dispatch(editInvoice((invoice as Invoice | undefined) ?? null));
    dispatch(setInvoiceModalOpen(true));
  };
}

export function useCreateHydratedInvoice() {
  const dispatch = useAppDispatch();

  return (invoice: Partial<HydratedInvoice>) => {
    dispatch(resetEditing());
    // Upcasting to satisfy the type, the logic within InvoiceController can
    // handle resolving the editing state correctly
    dispatch(editInvoice(invoice as unknown as Invoice));
    dispatch(setHydratedInvoice(invoice as unknown as HydratedInvoice));
    dispatch(setInvoiceModalOpen(true));
  };
}
